import { render, staticRenderFns } from "./IssueTrackingForm.vue?vue&type=template&id=6a322fdc"
import script from "./IssueTrackingForm.vue?vue&type=script&lang=js"
export * from "./IssueTrackingForm.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackingForm.vue?vue&type=style&index=0&id=6a322fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports